import { FC } from 'react'
import { Textarea } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import { useDarkMode } from '../contexts/DarkModeContext'

interface CreditBlock {
  id: string
  type: 'text' | 'images'
  text?: string
  images?: Array<{
    id: string
    url: string
    storage_path: string | null
    alt: string
  }>
}

interface ExperienceCreditsEditorTextBlockProps {
  creditsBlocks: CreditBlock[]
  block: CreditBlock
  onUpdateBlocks: (blocks: CreditBlock[]) => void
}

export const ExperienceCreditsEditorTextBlock: FC<ExperienceCreditsEditorTextBlockProps> = ({
  creditsBlocks,
  block,
  onUpdateBlocks,
}) => {
  const { darkMode } = useDarkMode()
  const { t } = useTranslation()

  const updateBlock = (blockId: string, newData: object) => {
    const blocks = (creditsBlocks ?? []).map((b) => (b.id === blockId ? { ...b, ...newData } : b))
    onUpdateBlocks(blocks)
  }

  return (
    <Textarea
      className="text-primary-600 focus:text-primary-700 dark:!text-base-gray-500 dark:focus:text-base-gray-400"
      value={block.text ?? ''}
      label={t('experienceCreditsEditor.creditsText')}
      onChange={(e) => updateBlock(block.id, { text: e.currentTarget.value ?? '' })}
      {...(darkMode && { color: 'blue-gray' })}
      labelProps={{
        className:
          'text-gray-600 dark:!text-gray-200 peer-focus:!text-gray-800 dark:peer-focus:!text-gray-100',
      }}
    />
  )
}
